import { BookingCalendarTypes } from './actionTypes';

export const getBookingEvents = () => ({
  type: BookingCalendarTypes.GET_EVENTS,
});

export const bookingApiSuccess = (actionType: any, data: any) => ({
  type: BookingCalendarTypes.API_SUCCESS,
  payload: { actionType, data },
});

export const bookingApiFail = (actionType: any, error: any) => ({
  type: BookingCalendarTypes.API_FAIL,
  payload: { actionType, error },
});

export const addNewBookingEvent = (event: any) => ({
  type: BookingCalendarTypes.ADD_NEW_EVENT,
  payload: event,
});

export const updateBookingEvent = (event: any) => ({
  type: BookingCalendarTypes.UPDATE_EVENT,
  payload: event,
});

export const updateBookingEventSuccess = (event: any) => ({
  type: BookingCalendarTypes.UPDATE_EVENT_SUCCESS,
  payload: event,
});

export const updateBookingEventFail = (error: any) => ({
  type: BookingCalendarTypes.UPDATE_EVENT_FAIL,
  payload: error,
});

export const deleteBookingEvent = (event: any) => ({
  type: BookingCalendarTypes.DELETE_EVENT,
  payload: event,
});

export const deleteBookingEventSuccess = (event: any) => ({
  type: BookingCalendarTypes.DELETE_EVENT_SUCCESS,
  payload: event,
});

export const deleteBookingEventFail = (error: any) => ({
  type: BookingCalendarTypes.DELETE_EVENT_FAIL,
  payload: error,
});

export const getBookingCategories = () => ({
  type: BookingCalendarTypes.GET_CATEGORIES,
});

export const getBookingCategoriesSuccess = (categories: any) => ({
  type: BookingCalendarTypes.GET_CATEGORIES_SUCCESS,
  payload: categories,
});

export const getBookingCategoriesFail = (error: any) => ({
  type: BookingCalendarTypes.GET_CATEGORIES_FAIL,
  payload: error,
});

export const resetBookingCalendar = (flag: any, value: any) => ({
  type: BookingCalendarTypes.RESET_CALENDAR,
  payload: { flag, value },
});
